import axiosInstance from '../axios';

export async function getExperimentosPagedRaw({
    id,
    serialNumber,
    protocolId,
    analysisId,
    status,
    startFrom,
    startTo,
    endFrom,
    endTo,
    page = 0,
    size = 20,
    sort = 'startDate',
    dir = 'desc',
    ativo,
    temLabResult,
} = {}) {
    const params = {
        id,
        serialNumber,
        protocolId,
        analysisId,
        status,
        startFrom,
        startTo,
        endFrom,
        endTo,
        page,
        size,
        sort,
        dir,
        ativo,
        // undefined some da query (axios omite): "todos" e a ausencia do parametro,
        // nao um terceiro valor.
        temLabResult,
    };

    const res = await axiosInstance.get('/experimento', { params });
    return res.data;
}

export async function getExperimentos(params = {}, fetchAll = true) {
    if (!fetchAll) {
        return await getExperimentosPagedRaw(params);
    }

    const out = [];
    let curPage = params.page ?? 0;
    const size = Math.min(Math.max(params.size ?? 200, 1), 200);
    const sort = params.sort ?? 'startDate';
    const dir = params.dir ?? 'desc';
    const ativo = params.ativo;
    const hardCap = 10000;

    for (;;) {
        const pageRes = await getExperimentosPagedRaw({
            ...params,
            page: curPage,
            size,
            sort,
            dir,
            ativo,
        });
        out.push(...(pageRes.items || []));
        const last = curPage + 1 >= (pageRes.totalPages || 1);
        const cap = out.length >= hardCap;
        if (last || cap) break;
        curPage += 1;
    }
    return out;
}

/**
 * Processa o experimento no modelo de inferência. O crm-back grava o resultado em
 * `predicao` e devolve o experimento atualizado. Pode levar até ~90 s.
 */
export async function processarExperimento(id) {
    if (!id) {
        throw new Error('O ID do experimento é obrigatório para processar.');
    }

    const res = await axiosInstance.post(`/experimento/processar`, null, {
        params: { id },
    });
    return res.data;
}

export async function addComentarioExperimento(id, comentario) {
    if (!id) {
        throw new Error('O ID do experimento é obrigatório para adicionar comentário.');
    }

    const payload = { comentario };

    const res = await axiosInstance.put(`/experimento/comentario`, payload, {
        params: { id },
    });

    return res.data;
}

export async function atualizarAmostraExperimento(id, nome, codigoAmostra) {
    if (!id) {
        throw new Error('O ID do experimento é obrigatório para atualizar a amostra.');
    }

    const payload = {
        nome: nome || '',
        codigoAmostra: codigoAmostra || '',
    };

    const res = await axiosInstance.put(`/experimento/amostra`, payload, {
        params: { id },
    });

    return res.data;
}

export async function atualizarDiluicaoExperimento(id, diluicao) {
    if (!id) {
        throw new Error('O ID do experimento é obrigatório para atualizar diluição.');
    }
    if (diluicao < 0 || diluicao > 10) {
        throw new Error('A diluição deve estar entre 0 e 10.');
    }

    const res = await axiosInstance.put(`/experimento/diluicao`, null, {
        params: {
            id,
            valor: diluicao,
        },
    });
    return res.data;
}

export async function excluirExperimento(id, motivo = '') {
    if (!id) throw new Error('O ID do experimento é obrigatório para excluir.');
    const res = await axiosInstance.delete(`/experimento`, {
        params: { id, motivo },
    });
    return res.data;
}

/** Desfaz a exclusão lógica do experimento (só ADMIN no backend). */
export async function restaurarExperimento(id) {
    if (!id) throw new Error('O ID do experimento é obrigatório para restaurar.');
    const res = await axiosInstance.put(`/experimento/restaurar`, null, { params: { id } });
    return res.data;
}

export async function encerrarExperimento(id, forcado = false, motivo = '') {
    if (!id) {
        throw new Error('O ID do experimento é obrigatório para encerrar.');
    }

    const res = await axiosInstance.put(`/experimento/encerrar`, null, {
        params: { id, forcado, motivo },
    });
    return res.data;
}

export async function encerrarExperimentoForcadoAdmin(id, motivo = '') {
    if (!id) {
        throw new Error('O ID do experimento é obrigatório para encerrar.');
    }

    const res = await axiosInstance.put(`/experimento/encerrar-admin`, null, {
        params: { id, motivo },
    });
    return res.data;
}

export async function getUltimaLeituraExperimento(id) {
    if (!id) {
        throw new Error('O ID do experimento é obrigatório.');
    }

    const res = await axiosInstance.get(`/experimento/ultima-leitura`, {
        params: { id },
    });
    return res.data || null;
}

export async function atualizarTagExperimento(id, tag, color) {
    if (!id) throw new Error('O ID do experimento é obrigatório.');

    const payload = {
        tag: tag || '',
        color: color || '',
    };

    const res = await axiosInstance.put(`/experimento/tag`, payload, {
        params: { id },
    });
    return res.data;
}

export async function atualizarTrainingLabelExperimento(id, label, motivo = '') {
    if (!id) throw new Error('O ID do experimento é obrigatório.');
    if (!label) throw new Error('O label de treinamento é obrigatório.');

    const payload = {
        label,
        motivo: motivo || '',
    };

    const res = await axiosInstance.put(`/experimento/training-label`, payload, {
        params: { id },
    });
    return res.data;
}
